import { TemporaryCampaignBudgetModel } from './TemporaryCampaignBudget'
import { CreativeSchedule } from './CreativeSchedule'

export class BudgetRequestModel {
  constructor(data) {
    const {
      id,
      budget,
      startTime,
      endTime,
      requestStatus,
      temporaryCampaignBudgets,
      creativeSchedules = [],
    } = data

    this.id = id
    this.budget = budget
    this.startTime = startTime
    this.endTime = endTime
    this.requestStatus = requestStatus
    this.temporaryCampaignBudgets = temporaryCampaignBudgets.map(
      TemporaryCampaignBudgetModel.assign,
    )
    this.creativeSchedules = creativeSchedules.map(CreativeSchedule.assign)
  }

  static assign(data) {
    return new BudgetRequestModel(data)
  }
}
